<template>
  <div class="dot" :class="{ active: active }" @click="goToPage()">
    <span class="text">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: ["id", "active", "title"],
  methods: {
    async goToPage() {
      this.$emit("click", this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-text-book {
  width: 100%;
}
.dot:not(.item-text-book) {
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin: 5px;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  text-align: center;
  line-height: 27px;
  position: relative;
  background-color: #f1f1f1;
  color: black;
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: 0.3s;
  cursor: pointer !important;
  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.3);
  }
  &.active {
    border: 1px solid rgba(0, 0, 0, 0.6);
  }
}
</style>
